import React from 'react';
import "../styles/contact.css";
import ContactImage from '../assets/contact.jpg';

const Contact = () => {
  return (
    <div className="contact-container">
      {/* Left Section - Image */}
      <div className="contact-image">
        <img src={ContactImage} alt="Contact Representative" />
      </div>

      {/* Right Section - Contact Form */}
      <div className="contact-form">
        <h2>CONTACT US</h2>
        <form>
          <label htmlFor="name">Full Name</label>
          <input type="text" id="name" name="name" placeholder="Enter your full name" required />

          <label htmlFor="subject">Subject</label>
          <input type="text" id="subject" name="subject" placeholder="Enter subject" required />

          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" placeholder="Write your message..." required></textarea>

          <button type="submit">SUBMIT</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
